// extracted by mini-css-extract-plugin
module.exports = {"storeDetailsCard":"StoreDetailsCard_storeDetailsCard__O3Try","storeDetailsCardTitle":"StoreDetailsCard_storeDetailsCardTitle__5BDrQ"};